export default "__VITE_ASSET__D1PBigY1__"